import { render, staticRenderFns } from "./VolDetail.vue?vue&type=template&id=28eb661f&scoped=true"
import script from "./VolDetail.vue?vue&type=script&lang=js"
export * from "./VolDetail.vue?vue&type=script&lang=js"
import style0 from "./VolDetail.vue?vue&type=style&index=0&id=28eb661f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb661f",
  null
  
)

export default component.exports